import home from '@/views/Home'
import list from '@/views/list'
import detail from '@/views/detail'
import webIndex from '@/views/webIndex/index'
import searchLT from '@/views/searchLT/index'
import playLT from '@/views/playLT/index'
import localCustoms from '@/views/localCustoms/index'

export let routes = [
    {
        path: '/',
        name: 'home', 
        component: home,
        children:[
          {
            path: '/',
            name: 'webIndex', 
            component: webIndex,
            meta: {
              requireAuth: true,
              title:'网站首页'
            },
          },
          {
            path: 'searchLT',
            name: 'searchLT', 
            component: searchLT,
            meta: {
              requireAuth: true,
              title:'探索新县'
            },
          },
          {
            path: 'playLT',
            name: 'playLT', 
            component: playLT,
            meta: {
              requireAuth: true,
              title:'玩在新县'
            },
          },
          {
            path: 'localCustoms',
            name: 'localCustoms', 
            component: localCustoms,
            meta: {
              requireAuth: true,
              title:'乡土民情'
            },
          },
          {
            path: 'list',
            name: 'list', 
            component: list,
            meta: {
              requireAuth: true,
            },
          },
          {
            path: 'detail',
            name: 'detail', 
            component: detail,
            meta: {
              requireAuth: true,
            },
          },
        ]
    },
]